import React, { useState } from 'react';
import { Form, Button } from 'antd';
import './Login.css';
import { postPassword, NewPasswordFields, ErrorList } from '../components/ChangePasswordModal';

// Opened from the link in the reset mail: /reset-password?uid=..&token=..
const ResetPasswordPage = () => {
  const params = new URLSearchParams(window.location.search);
  const uid = params.get('uid');
  const token = params.get('token');
  const [errors, setErrors] = useState([]);
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState('');

  const onFinish = async (values) => {
    setSaving(true);
    const result = await postPassword('reset/confirm/', { uid, token, password: values.new_password });
    setSaving(false);
    if (result.ok) setDone(result.detail);
    else setErrors(result.errors);
  };

  let content;
  if (!uid || !token) {
    content = <div>This link is incomplete. Please open the link from the mail again, or request a new one on the login page.</div>;
  } else if (done) {
    content = <div>{done}</div>;
  } else {
    content = (
      <Form layout="vertical" onFinish={onFinish}>
        <ErrorList errors={errors} />
        <NewPasswordFields />
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" loading={saving}>
            Set new password
          </Button>
        </Form.Item>
      </Form>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <h2 style={{ marginTop: 0 }}>Set a new password</h2>
        {content}
        <div style={{ marginTop: 16, fontSize: 15 }}>
          <a href="/login">Back to login</a>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
